<template>
    <div class="q-py-md">
        <q-table
            :data="ordersHistory"
            :columns="columns"
            :pagination.sync="pagination"
            :rows-per-page-options="rowsPerPageOptions"
            :loading="isFetchingOrdersHistory"
            binary-state-sort
            row-key="id"
            flat
            @request="request"
        >
            <template v-slot:body="props">
                <!-- history row template -->
                <q-tr :props="props">
                    <!-- expand icon column -->
                    <q-td auto-width>
                        <q-btn
                            size="sm"
                            color="black"
                            round
                            dense
                            :icon="props.expand ? 'remove' : 'add'"
                            @click="expandRow(props)"
                        />
                    </q-td>

                    <!-- history operation description -->
                    <q-td key="id" :props="props">
                        {{ props.row.id }}
                    </q-td>

                    <!-- history operation description -->
                    <q-td key="order_status" :props="props">
                        {{
                            JSONParseTranslations(
                                props.row.orderStatus.title,
                                locale.key
                            )
                        }}
                    </q-td>

                    <!-- history operation date -->
                    <q-td key="order_date" :props="props">
                        {{ formatDate(props.row.order_date) }}
                    </q-td>

                    <!-- history operation price -->
                    <q-td key="total" :props="props">
                        <div v-if="props.row.currencies.definition">
                            {{
                                new Intl.NumberFormat(
                                    JSON.parse(props.row.currencies.definition)[
                                        'locale'
                                    ],
                                    {
                                        style: 'currency',
                                        currency: props.row.currencies.key,
                                    }
                                ).format(
                                    parseFloat(
                                        JSON.parse(props.row.total)[
                                            props.row.currencies.key
                                        ]
                                    )
                                )
                            }}
                        </div>
                    </q-td>

                    <!-- history operation payment type -->
                    <!-- <q-td key="payment_method" :props="props">
                        {{
                            JSONParseTranslations(
                                props.row.paymentMethod.title,
                                locale.key
                            )
                        }}
                    </q-td> -->

                    <!-- view receipt button -->
                    <!-- <q-td key="receipt" :props="props">
                        <q-btn
                            :to="'/receipt/' + props.row.receiptId"
                            class="q-px-sm"
                            color="secondary"
                            :label="$t('general.receipt')"
                            dense
                            unelevated
                        />
                    </q-td> -->
                    <q-td key="details" :props="props">
                        <q-btn
                            :to="{
                                name: 'SingleOrder',
                                params: { orderId: props.row.id },
                            }"
                            class="q-px-sm"
                            color="secondary"
                            :label="$t('general.view_order')"
                            dense
                            unelevated
                        />
                    </q-td>
                </q-tr>

                <!-- expanded row template -->
                <q-tr
                    v-show="props.expand"
                    :props="props"
                    style="background: #f6f6f6"
                >
                    <q-td colspan="100%">
                        <div class="row order-items-headings q-col-gutter-x-sm">
                            <div class="col-4">
                                {{ $tc('general.items', 1) }}
                            </div>
                            <div class="col-1 text-center">
                                {{ $t('general.created_at') }}
                            </div>
                            <div class="col-2 text-right">
                                {{ $t('general.unit_price') }}
                            </div>
                            <div class="col-1 text-right">
                                {{ $t('general.discount') }}
                            </div>
                            <div class="col text-right">
                                {{ $t('general.quantity') }}
                            </div>
                            <div class="col-2 text-right">
                                {{ $t('general.total') }}
                            </div>
                        </div>
                        <!-- expanded rows: order items -->
                        <div
                            v-for="course in props.row.orderItems"
                            :key="course.course_id"
                            class="text-left row q-col-gutter-x-sm q-mb-sm"
                        >
                            <div class="col-12 q-mb-sm">
                                <q-separator></q-separator>
                            </div>
                            <div class="col-auto">
                                <q-img
                                    :src="course.thumb"
                                    spinner-color="white"
                                    :ratio="16 / 9"
                                    width="64px"
                                />
                            </div>
                            <div class="col" style="white-space: initial">
                                {{
                                    JSONParseTranslations(
                                        course.courses.title,
                                        locale.key
                                    )
                                }}
                                <ServicesInCourseBadge
                                    v-if="course.course_id"
                                    :course-id="course.course_id"
                                >
                                </ServicesInCourseBadge>
                            </div>
                            <div class="col-1 text-center">
                                {{ formatDate(course.created_at) }}
                            </div>

                            <div class="col-2 text-right">
                                <div v-if="props.row.currencies.definition">
                                    {{
                                        new Intl.NumberFormat(
                                            JSON.parse(
                                                props.row.currencies.definition
                                            )['locale'],
                                            {
                                                style: 'currency',
                                                currency:
                                                    props.row.currencies.key,
                                            }
                                        ).format(
                                            parseFloat(
                                                JSON.parse(course.unit_price)[
                                                    props.row.currencies.key
                                                ]
                                            ).toFixed(2)
                                        )
                                    }}
                                </div>
                            </div>
                            <div class="col-1 text-right">
                                {{ course.discount }}
                            </div>
                            <div class="col-2 text-right">
                                {{ course.quantity }}
                            </div>
                            <div class="col-2 text-right">
                                {{
                                    new Intl.NumberFormat(
                                        JSON.parse(
                                            props.row.currencies.definition
                                        )['locale'],
                                        {
                                            style: 'currency',
                                            currency: props.row.currencies.key,
                                        }
                                    ).format(
                                        JSON.parse(course.item_total)[
                                            props.row.currencies.key
                                        ]
                                    )
                                }}
                            </div>
                        </div>
                        <!-- expanded rows: order services -->
                        <div
                            v-for="service in props.row.orderServices"
                            :key="service.service_id"
                            class="text-left row q-col-gutter-x-sm q-mb-sm"
                        >
                            <div class="col-12 q-mb-sm">
                                <q-separator></q-separator>
                            </div>
                            <div class="col-auto">
                                <q-icon name="restaurant" size="md"></q-icon>
                            </div>
                            <div class="col" style="white-space: initial">
                                {{ service.services.name }}
                            </div>
                            <div class="col-1 text-center">
                                {{ formatDate(service.created_at) }}
                            </div>

                            <div class="col-2 text-right">
                                <div v-if="props.row.currencies.definition">
                                    {{
                                        new Intl.NumberFormat(
                                            JSON.parse(
                                                props.row.currencies.definition
                                            )['locale'],
                                            {
                                                style: 'currency',
                                                currency:
                                                    props.row.currencies.key,
                                            }
                                        ).format(
                                            parseFloat(
                                                JSON.parse(service.unit_price)[
                                                    props.row.currencies.key
                                                ]
                                            ).toFixed(2)
                                        )
                                    }}
                                </div>
                            </div>
                            <div class="col-1 text-right">
                                {{ service.discount }}
                            </div>
                            <div class="col-2 text-right">
                                {{ service.quantity }}
                            </div>
                            <div class="col-2 text-right">
                                {{
                                    new Intl.NumberFormat(
                                        JSON.parse(
                                            props.row.currencies.definition
                                        )['locale'],
                                        {
                                            style: 'currency',
                                            currency: props.row.currencies.key,
                                        }
                                    ).format(
                                        JSON.parse(service.item_total)[
                                            props.row.currencies.key
                                        ]
                                    )
                                }}
                            </div>
                        </div>
                    </q-td>
                </q-tr>
            </template>
        </q-table>
    </div>
</template>

<script>
import ServicesInCourseBadge from '@/components/orders/ServicesInCourseBadge'
import translate from '@/local-shared/mixins/translate'
import notify from '@/local-shared/mixins/notify'
import ordersService from '@/services/modules/orders'
import picturesService from '@/services/pictures'
import encoders from '@/helpers/encoders'
import store from '@/store'
import moment from 'moment'

const loadingKeys = {
    fetchingOrdersHistory: 'fetching-orders-history',
    fetchingOrderItems: 'fetching-order-items',
}

export default {
    name: 'OrdersHistory',

    components: {
        ServicesInCourseBadge,
    },

    mixins: [translate, notify],

    data() {
        return {
            ordersHistory: [],

            pagination: {
                sortBy: 'id',
                descending: true,
                page: 1,
                rowsPerPage: 10,
                rowsNumber: 0,
            },

            rowsPerPageOptions: [5, 10, 25, 50, 100],
        }
    },

    computed: {
        columns() {
            return [
                { name: 'expand', align: 'left', label: '', sortable: false },
                {
                    name: 'id',
                    label: 'ID',
                    field: 'id',
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'order_status',
                    label: this.$t('general.status'),
                    field: 'orderStatus',
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'order_date',
                    label: this.$t('general.order_date'),
                    field: 'order_date',
                    align: 'left',
                    sortable: true,
                },
                {
                    name: 'total',
                    label: this.$t('general.total'),
                    field: 'total',
                    align: 'right',
                    sortable: true,
                },
                // {
                //     name: 'payment_method',
                //     label: this.$t('general.payment_method'),
                //     field: 'payment_method',
                //     align: 'left',
                //     sortable: true,
                // },
                // {
                //     name: 'receipt',
                //     align: 'center',
                //     label: this.$t('general.receipt'),
                //     field: 'receiptId',
                //     sortable: false,
                // },
                {
                    name: 'details',
                    align: 'center',
                    label: this.$t('general.details'),
                    sortable: false,
                },
            ]
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },

        currencyList() {
            return store.getters['currency/currencyList']
        },

        isLoading() {
            return this.isFetchingOrdersHistory || this.isFetchingOrderItems
        },

        isFetchingOrdersHistory() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingOrdersHistory
            ).length
        },

        isFetchingOrderItems() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingOrderItems
            ).length
        },

        user() {
            return store.getters['session/user']
        },
    },

    async created() {
        await this.fetchOrders()
    },

    methods: {
        request(props) {
            const { page, rowsPerPage, sortBy, descending } = props.pagination

            this.pagination.page = page
            this.pagination.rowsPerPage = rowsPerPage
            this.pagination.sortBy = sortBy
            this.pagination.descending = descending

            this.fetchOrders()
        },

        mapColumn(value) {
            //return value == null ? this.pagination.sortBy : value

            if (value == null) {
                return this.pagination.sortBy
            }
            if (value == 'order_status') {
                return 'orders.orderstatus_id'
            }
            // if (value == 'payment_method') {
            //     return 'orders.payment_method_id'
            // }

            return value
        },

        mapOrder(value) {
            return value == true ? 'desc' : 'asc'
        },

        async fetchOrders() {
            this.loadingAdd(loadingKeys.fetchingOrdersHistory)

            let parameters = {
                filter: {
                    user: this.user.id,
                },
                pagination: {
                    perPage: this.pagination.rowsPerPage,
                    currentPage: this.pagination.page,
                },
                orderBy: [
                    {
                        column: this.mapColumn(this.pagination.sortBy),
                        direction: this.mapOrder(this.pagination.descending),
                    },
                ],
                relations: {
                    orderItems: true,
                    currencies: true,
                    paymentMethod: true,
                    orderStatus: true,
                    orderServices: true,
                },
            }

            let response = await ordersService.retrieve(parameters)

            if (response.status === 200) {
                this.ordersHistory = response.data.results
                this.pagination.rowsNumber = response.data.pagination.total
            } else {
                this.notifyError(response.data.message)
            }

            this.loadingRemove(loadingKeys.fetchingOrdersHistory)
        },

        async expandRow(props) {
            if (!props.expand) {
                await this.fetchOrderItemsPictures(props.row)
            }
            return (props.expand = !props.expand)
        },

        getSymbol(key) {
            let currency = this.currencyList.find((item) => item.key === key)
            return JSON.parse(currency.definition)['symbol']
        },

        async fetchOrderItemsPictures(order) {
            this.loadingAdd(loadingKeys.fetchingOrderItems)

            let index = this.ordersHistory.findIndex(
                (item) => item.id === order.id
            )
            let orderItems = this.ordersHistory[index].orderItems

            await Promise.all(
                orderItems.map(async (item) => {
                    let imageResponse = await picturesService.retrieveById(
                        item.courses.coursepicture_id
                    )
                    if (imageResponse.status === 200) {
                        item.thumb = encoders.arrayBufferToBase64(imageResponse)
                    } else {
                        item.thumb = require('@/assets/logo.svg')
                    }
                })
            )

            //this.ordersHistory[index].orderItems = _.cloneDeep(orderItems)

            this.loadingRemove(loadingKeys.fetchingOrderItems)
        },

        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(value) {
            return value
                ? moment(String(value)).format(this.dateMaskFormat())
                : null
        },
    },
}
</script>
